const vsLightTheme = {
	"$schema": "vscode://schemas/color-theme",
	"type": "light",
	"colors": {
		"activityBarBadge.background": "#007acc",
		"editor.background": "#ffffff",
		"editor.foreground": "#000000",
		"editor.inactiveSelectionBackground": "#e5ebf1",
		"editor.selectionHighlightBackground": "#add6ff80",
		"editorIndentGuide.activeBackground": "#939393",
		"editorIndentGuide.background": "#d3d3d3",
		"editorSuggestWidget.background": "#f3f3f3",
		"input.placeholderForeground": "#767676",
		"list.hoverBackground": "#e8e8e8",
		"notebook.cellBorderColor": "#e8e8e8",
		"searchEditor.textInputBorder": "#cecece",
		"settings.numberInputBorder": "#cecece",
		"settings.textInputBorder": "#cecece",
		"sideBarSectionHeader.background": "#00000000",
		"sideBarSectionHeader.border": "#61616130",
		"sideBarTitle.foreground": "#6f6f6f",
		"statusBarItem.errorBackground": "#c72e0f",
		"statusBarItem.remoteBackground": "#16825d",
		"statusBarItem.remoteForeground": "#ffffff",
		"tab.lastPinnedBorder": "#61616130",
		"activityBar.activeBorder": "#ffffff",
		"activityBar.background": "#2c2c2c",
		"activityBar.dropBorder": "#ffffff",
		"activityBar.foreground": "#ffffff",
		"activityBar.inactiveForeground": "#ffffff66",
		"activityBarBadge.foreground": "#ffffff",
		"badge.background": "#c4c4c4",
		"badge.foreground": "#333333",
		"breadcrumb.activeSelectionForeground": "#4e4e4e",
		"breadcrumb.background": "#ffffff",
		"breadcrumb.focusForeground": "#4e4e4e",
		"breadcrumb.foreground": "#616161cc",
		"breadcrumbPicker.background": "#f3f3f3",
		"button.background": "#007acc",
		"button.foreground": "#ffffff",
		"button.hoverBackground": "#0062a3",
		"button.secondaryBackground": "#5f6a79",
		"button.secondaryForeground": "#ffffff",
		"button.secondaryHoverBackground": "#4c5561",
		"charts.blue": "#75beff",
		"charts.foreground": "#616161",
		"charts.green": "#388a34",
		"charts.lines": "#61616180",
		"charts.orange": "#d18616",
		"charts.purple": "#652d90",
		"charts.red": "#e51400",
		"charts.yellow": "#e9a700",
		"checkbox.background": "#ffffff",
		"checkbox.border": "#cecece",
		"debugConsole.errorForeground": "#a1260d",
		"debugConsole.infoForeground": "#75beff",
		"debugConsole.sourceForeground": "#616161",
		"debugConsole.warningForeground": "#e9a700",
		"debugConsoleInputIcon.foreground": "#616161",
		"debugExceptionWidget.background": "#f1dfde",
		"debugExceptionWidget.border": "#a31515",
		"debugIcon.breakpointCurrentStackframeForeground": "#ffcc00",
		"debugIcon.breakpointDisabledForeground": "#848484",
		"debugIcon.breakpointForeground": "#e51400",
		"debugIcon.breakpointStackframeForeground": "#89d185",
		"debugIcon.breakpointUnverifiedForeground": "#848484",
		"debugIcon.continueForeground": "#007acc",
		"debugIcon.disconnectForeground": "#a1260d",
		"debugIcon.pauseForeground": "#007acc",
		"debugIcon.restartForeground": "#388a34",
		"debugIcon.startForeground": "#388a34",
		"debugIcon.stepBackForeground": "#007acc",
		"debugIcon.stepIntoForeground": "#007acc",
		"debugIcon.stepOutForeground": "#007acc",
		"debugIcon.stepOverForeground": "#007acc",
		"debugIcon.stopForeground": "#a1260d",
		"debugTokenExpression.boolean": "#0000ff",
		"debugTokenExpression.error": "#e51400",
		"debugTokenExpression.name": "#9b46b0",
		"debugTokenExpression.number": "#098658",
		"debugTokenExpression.string": "#a31515",
		"debugTokenExpression.value": "#6c6c6ccc",
		"debugToolBar.background": "#f3f3f3",
		"debugView.exceptionLabelBackground": "#a31515",
		"debugView.exceptionLabelForeground": "#ffffff",
		"debugView.stateLabelBackground": "#88888844",
		"debugView.stateLabelForeground": "#616161",
		"debugView.valueChangedHighlight": "#569cd6",
		"descriptionForeground": "#717171",
		"diffEditor.diagonalFill": "#22222233",
		"diffEditor.insertedTextBackground": "#9bb95533",
		"diffEditor.removedTextBackground": "#ff000033",
		"dropdown.background": "#ffffff",
		"dropdown.border": "#cecece",
		"editor.findMatchBackground": "#a8ac94",
		"editor.findMatchHighlightBackground": "#ea5c0055",
		"editor.findRangeHighlightBackground": "#b4b4b44d",
		"editor.focusedStackFrameHighlightBackground": "#cee7ce73",
		"editor.foldBackground": "#add6ff4d",
		"editor.hoverHighlightBackground": "#add6ff26",
		"editor.lineHighlightBorder": "#eeeeee",
		"editor.linkedEditingBackground": "#ff00004d",
		"editor.rangeHighlightBackground": "#fdff0033",
		"editor.selectionBackground": "#add6ff",
		"editor.snippetFinalTabstopHighlightBorder": "#0a326480",
		"editor.snippetTabstopHighlightBackground": "#0a326433",
		"editor.stackFrameHighlightBackground": "#ffff6673",
		"editor.symbolHighlightBackground": "#ea5c0055",
		"editor.wordHighlightBackground": "#57575740",
		"editor.wordHighlightStrongBackground": "#0e639c40",
		"editorActiveLineNumber.foreground": "#0b216f",
		"editorBracketMatch.background": "#0064001a",
		"editorBracketMatch.border": "#b9b9b9",
		"editorCodeLens.foreground": "#999999",
		"editorCursor.foreground": "#000000",
		"editorError.foreground": "#e51400",
		"editorGroup.border": "#e7e7e7",
		"editorGroup.dropBackground": "#2677cb2e",
		"editorGroupHeader.noTabsBackground": "#ffffff",
		"editorGroupHeader.tabsBackground": "#f3f3f3",
		"editorGutter.addedBackground": "#81b88b",
		"editorGutter.background": "#ffffff",
		"editorGutter.commentRangeForeground": "#c5c5c5",
		"editorGutter.deletedBackground": "#ca4b51",
		"editorGutter.foldingControlForeground": "#424242",
		"editorGutter.modifiedBackground": "#66afe0",
		"editorHint.foreground": "#6c6c6c",
		"editorHoverWidget.background": "#f3f3f3",
		"editorHoverWidget.border": "#c8c8c8",
		"editorHoverWidget.foreground": "#616161",
		"editorHoverWidget.statusBarBackground": "#e7e7e7",
		"editorInfo.foreground": "#75beff",
		"editorLightBulb.foreground": "#ddb100",
		"editorLightBulbAutoFix.foreground": "#007acc",
		"editorLineNumber.activeForeground": "#0b216f",
		"editorLineNumber.foreground": "#237893",
		"editorLink.activeForeground": "#0000ff",
		"editorMarkerNavigation.background": "#ffffff",
		"editorMarkerNavigationError.background": "#e51400",
		"editorMarkerNavigationInfo.background": "#75beff",
		"editorMarkerNavigationWarning.background": "#e9a700",
		"editorOverviewRuler.addedForeground": "#81b88b99",
		"editorOverviewRuler.border": "#7f7f7f4d",
		"editorOverviewRuler.bracketMatchForeground": "#a0a0a0",
		"editorOverviewRuler.commonContentForeground": "#60606066",
		"editorOverviewRuler.currentContentForeground": "#40c8ae80",
		"editorOverviewRuler.deletedForeground": "#ca4b5199",
		"editorOverviewRuler.errorForeground": "#ff1212b3",
		"editorOverviewRuler.findMatchForeground": "#d186167e",
		"editorOverviewRuler.incomingContentForeground": "#40a6ff80",
		"editorOverviewRuler.infoForeground": "#75beff",
		"editorOverviewRuler.modifiedForeground": "#66afe099",
		"editorOverviewRuler.rangeHighlightForeground": "#007acc99",
		"editorOverviewRuler.selectionHighlightForeground": "#a0a0a0cc",
		"editorOverviewRuler.warningForeground": "#e9a700",
		"editorOverviewRuler.wordHighlightForeground": "#a0a0a0cc",
		"editorOverviewRuler.wordHighlightStrongForeground": "#c0a0c0cc",
		"editorPane.background": "#ffffff",
		"editorRuler.foreground": "#d3d3d3",
		"editorSuggestWidget.border": "#c8c8c8",
		"editorSuggestWidget.foreground": "#000000",
		"editorSuggestWidget.highlightForeground": "#0066bf",
		"editorSuggestWidget.selectedBackground": "#d6ebff",
		"editorUnnecessaryCode.opacity": "#00000077",
		"editorWarning.foreground": "#e9a700",
		"editorWhitespace.foreground": "#33333333",
		"editorWidget.background": "#f3f3f3",
		"editorWidget.border": "#c8c8c8",
		"editorWidget.foreground": "#616161",
		"errorForeground": "#a1260d",
		"extensionBadge.remoteBackground": "#007acc",
		"extensionBadge.remoteForeground": "#ffffff",
		"extensionButton.prominentBackground": "#007acc",
		"extensionButton.prominentForeground": "#ffffff",
		"extensionButton.prominentHoverBackground": "#0062a3",
		"focusBorder": "#0090f1",
		"foreground": "#616161",
		"gitDecoration.addedResourceForeground": "#587c0c",
		"gitDecoration.conflictingResourceForeground": "#6c6cc4",
		"gitDecoration.deletedResourceForeground": "#ad0707",
		"gitDecoration.ignoredResourceForeground": "#8e8e90",
		"gitDecoration.modifiedResourceForeground": "#895503",
		"gitDecoration.stageDeletedResourceForeground": "#ad0707",
		"gitDecoration.stageModifiedResourceForeground": "#895503",
		"gitDecoration.submoduleResourceForeground": "#1258a7",
		"gitDecoration.untrackedResourceForeground": "#007100",
		"gitlens.gutterBackgroundColor": "#0000000c",
		"gitlens.gutterForegroundColor": "#747474",
		"gitlens.gutterUncommittedForegroundColor": "#00bcf299",
		"gitlens.lineHighlightBackgroundColor": "#00bcf233",
		"gitlens.lineHighlightOverviewRulerColor": "#00bcf299",
		"gitlens.trailingLineBackgroundColor": "#00000000",
		"gitlens.trailingLineForegroundColor": "#99999959",
		"gitlens.viewChangesToPullIconColor": "#b15e35",
		"gitlens.viewChangesToPushIconColor": "#35b15e",
		"gitlens.viewCommitToPushIconColor": "#35b15e",
		"icon.foreground": "#424242",
		"imagePreview.border": "#80808059",
		"input.background": "#ffffff",
		"input.foreground": "#616161",
		"inputOption.activeBackground": "#0090f133",
		"inputOption.activeBorder": "#007acc00",
		"inputOption.activeForeground": "#000000",
		"inputValidation.errorBackground": "#f2dede",
		"inputValidation.errorBorder": "#be1100",
		"inputValidation.infoBackground": "#d6ecf2",
		"inputValidation.infoBorder": "#007acc",
		"inputValidation.warningBackground": "#f6f5d2",
		"inputValidation.warningBorder": "#b89500",
		"list.activeSelectionBackground": "#0060c0",
		"list.activeSelectionForeground": "#ffffff",
		"list.deemphasizedForeground": "#8e8e90",
		"list.dropBackground": "#d6ebff",
		"list.errorForeground": "#b01011",
		"list.filterMatchBackground": "#ea5c0055",
		"list.focusBackground": "#d6ebff",
		"list.highlightForeground": "#0066bf",
		"list.inactiveSelectionBackground": "#e4e6f1",
		"list.invalidItemForeground": "#b89500",
		"list.warningForeground": "#855f00",
		"listFilterWidget.background": "#efc1ad",
		"listFilterWidget.noMatchesOutline": "#be1100",
		"listFilterWidget.outline": "#00000000",
		"menu.background": "#ffffff",
		"menu.foreground": "#616161",
		"menu.selectionBackground": "#0060c0",
		"menu.selectionForeground": "#ffffff",
		"menu.separatorBackground": "#888888",
		"menubar.selectionBackground": "#0000001a",
		"menubar.selectionForeground": "#333333",
		"merge.commonContentBackground": "#60606029",
		"merge.commonHeaderBackground": "#60606066",
		"merge.currentContentBackground": "#40c8ae33",
		"merge.currentHeaderBackground": "#40c8ae80",
		"merge.incomingContentBackground": "#40a6ff33",
		"merge.incomingHeaderBackground": "#40a6ff80",
		"minimap.errorHighlight": "#ff1212b3",
		"minimap.findMatchHighlight": "#d18616",
		"minimap.selectionHighlight": "#add6ff",
		"minimap.warningHighlight": "#e9a700",
		"minimapGutter.addedBackground": "#81b88b",
		"minimapGutter.deletedBackground": "#ca4b51",
		"minimapGutter.modifiedBackground": "#66afe0",
		"minimapSlider.activeBackground": "#0000004d",
		"minimapSlider.background": "#64646433",
		"minimapSlider.hoverBackground": "#64646459",
		"notebook.cellInsertionIndicator": "#0090f1",
		"notebook.cellStatusBarItemHoverBackground": "#00000014",
		"notebook.cellToolbarSeparator": "#80808059",
		"notebook.focusedCellBorder": "#0090f1",
		"notebook.focusedEditorBorder": "#0090f1",
		"notebook.focusedRowBorder": "#0000001f",
		"notebook.outputContainerBackgroundColor": "#e8e8e8",
		"notebook.rowHoverBackground": "#d6ebff47",
		"notebook.selectedCellBorder": "#e8e8e8",
		"notebook.symbolHighlightBackground": "#fdff0033",
		"notebookScrollbarSlider.activeBackground": "#00000099",
		"notebookScrollbarSlider.background": "#64646466",
		"notebookScrollbarSlider.hoverBackground": "#646464b3",
		"notebookStatusErrorIcon.foreground": "#a1260d",
		"notebookStatusRunningIcon.foreground": "#616161",
		"notebookStatusSuccessIcon.foreground": "#388a34",
		"notificationCenterHeader.background": "#e7e7e7",
		"notificationLink.foreground": "#006ab1",
		"notifications.background": "#f3f3f3",
		"notifications.border": "#e7e7e7",
		"notifications.foreground": "#616161",
		"notificationsErrorIcon.foreground": "#e51400",
		"notificationsInfoIcon.foreground": "#75beff",
		"notificationsWarningIcon.foreground": "#e9a700",
		"panel.background": "#ffffff",
		"panel.border": "#80808059",
		"panel.dropBorder": "#424242",
		"panelInput.border": "#dddddd",
		"panelSection.border": "#80808059",
		"panelSection.dropBackground": "#2677cb2e",
		"panelSectionHeader.background": "#80808033",
		"panelTitle.activeBorder": "#424242",
		"panelTitle.activeForeground": "#424242",
		"panelTitle.inactiveForeground": "#424242bf",
		"peekView.border": "#007acc",
		"peekViewEditor.background": "#f2f8fc",
		"peekViewEditor.matchHighlightBackground": "#f5d802de",
		"peekViewEditorGutter.background": "#f2f8fc",
		"peekViewResult.background": "#f3f3f3",
		"peekViewResult.fileForeground": "#1e1e1e",
		"peekViewResult.lineForeground": "#646465",
		"peekViewResult.matchHighlightBackground": "#ea5c004d",
		"peekViewResult.selectionBackground": "#3399ff33",
		"peekViewResult.selectionForeground": "#6c6c6c",
		"peekViewTitle.background": "#ffffff",
		"peekViewTitleDescription.foreground": "#616161e6",
		"peekViewTitleLabel.foreground": "#333333",
		"pickerGroup.border": "#cccedb",
		"pickerGroup.foreground": "#0066bf",
		"problemsErrorIcon.foreground": "#e51400",
		"problemsInfoIcon.foreground": "#75beff",
		"problemsWarningIcon.foreground": "#e9a700",
		"progressBar.background": "#0e70c0",
		"quickInput.background": "#f3f3f3",
		"quickInput.foreground": "#616161",
		"quickInputTitle.background": "#0000000f",
		"scm.providerBorder": "#c8c8c8",
		"scrollbar.shadow": "#dddddd",
		"scrollbarSlider.activeBackground": "#00000099",
		"scrollbarSlider.background": "#64646466",
		"scrollbarSlider.hoverBackground": "#646464b3",
		"searchEditor.findMatchBackground": "#ea5c0038",
		"settings.checkboxBackground": "#ffffff",
		"settings.checkboxBorder": "#cecece",
		"settings.dropdownBackground": "#ffffff",
		"settings.dropdownBorder": "#cecece",
		"settings.dropdownListBorder": "#c8c8c8",
		"settings.focusedRowBackground": "#d6ebff66",
		"settings.headerForeground": "#444444",
		"settings.modifiedItemIndicator": "#66afe0",
		"settings.numberInputBackground": "#ffffff",
		"settings.numberInputForeground": "#616161",
		"settings.textInputBackground": "#ffffff",
		"settings.textInputForeground": "#616161",
		"sideBar.background": "#f3f3f3",
		"sideBar.dropBackground": "#2677cb2e",
		"statusBar.background": "#007acc",
		"statusBar.debuggingBackground": "#cc6633",
		"statusBar.debuggingForeground": "#ffffff",
		"statusBar.foreground": "#ffffff",
		"statusBar.noFolderBackground": "#68217a",
		"statusBar.noFolderForeground": "#ffffff",
		"statusBarItem.activeBackground": "#ffffff2e",
		"statusBarItem.errorForeground": "#ffffff",
		"statusBarItem.hoverBackground": "#ffffff1f",
		"statusBarItem.prominentBackground": "#00000080",
		"statusBarItem.prominentForeground": "#ffffff",
		"statusBarItem.prominentHoverBackground": "#0000004d",
		"symbolIcon.arrayForeground": "#616161",
		"symbolIcon.booleanForeground": "#616161",
		"symbolIcon.classForeground": "#d67e00",
		"symbolIcon.colorForeground": "#616161",
		"symbolIcon.constantForeground": "#616161",
		"symbolIcon.constructorForeground": "#652d90",
		"symbolIcon.enumeratorForeground": "#d67e00",
		"symbolIcon.enumeratorMemberForeground": "#007acc",
		"symbolIcon.eventForeground": "#d67e00",
		"symbolIcon.fieldForeground": "#007acc",
		"symbolIcon.fileForeground": "#616161",
		"symbolIcon.folderForeground": "#616161",
		"symbolIcon.functionForeground": "#652d90",
		"symbolIcon.interfaceForeground": "#007acc",
		"symbolIcon.keyForeground": "#616161",
		"symbolIcon.keywordForeground": "#616161",
		"symbolIcon.methodForeground": "#652d90",
		"symbolIcon.moduleForeground": "#616161",
		"symbolIcon.namespaceForeground": "#616161",
		"symbolIcon.nullForeground": "#616161",
		"symbolIcon.numberForeground": "#616161",
		"symbolIcon.objectForeground": "#616161",
		"symbolIcon.operatorForeground": "#616161",
		"symbolIcon.packageForeground": "#616161",
		"symbolIcon.propertyForeground": "#616161",
		"symbolIcon.referenceForeground": "#616161",
		"symbolIcon.snippetForeground": "#616161",
		"symbolIcon.stringForeground": "#616161",
		"symbolIcon.structForeground": "#616161",
		"symbolIcon.textForeground": "#616161",
		"symbolIcon.typeParameterForeground": "#616161",
		"symbolIcon.unitForeground": "#616161",
		"symbolIcon.variableForeground": "#007acc",
		"tab.activeBackground": "#ffffff",
		"tab.activeForeground": "#333333",
		"tab.activeModifiedBorder": "#33aaee",
		"tab.border": "#f3f3f3",
		"tab.inactiveBackground": "#ececec",
		"tab.inactiveForeground": "#333333b3",
		"tab.inactiveModifiedBorder": "#33aaee80",
		"tab.unfocusedActiveBackground": "#ffffff",
		"tab.unfocusedActiveForeground": "#333333b3",
		"tab.unfocusedActiveModifiedBorder": "#33aaeeb3",
		"tab.unfocusedInactiveBackground": "#ececec",
		"tab.unfocusedInactiveForeground": "#33333359",
		"tab.unfocusedInactiveModifiedBorder": "#33aaee40",
		"terminal.ansiBlack": "#000000",
		"terminal.ansiBlue": "#0451a5",
		"terminal.ansiBrightBlack": "#666666",
		"terminal.ansiBrightBlue": "#0451a5",
		"terminal.ansiBrightCyan": "#0598bc",
		"terminal.ansiBrightGreen": "#14ce14",
		"terminal.ansiBrightMagenta": "#bc05bc",
		"terminal.ansiBrightRed": "#cd3131",
		"terminal.ansiBrightWhite": "#a5a5a5",
		"terminal.ansiBrightYellow": "#b5ba00",
		"terminal.ansiCyan": "#0598bc",
		"terminal.ansiGreen": "#00bc00",
		"terminal.ansiMagenta": "#bc05bc",
		"terminal.ansiRed": "#cd3131",
		"terminal.ansiWhite": "#555555",
		"terminal.ansiYellow": "#949800",
		"terminal.border": "#80808059",
		"terminal.foreground": "#333333",
		"terminal.selectionBackground": "#00000040",
		"textBlockQuote.background": "#7f7f7f1a",
		"textBlockQuote.border": "#007acc80",
		"textCodeBlock.background": "#dcdcdc66",
		"textLink.activeForeground": "#006ab1",
		"textLink.foreground": "#006ab1",
		"textPreformat.foreground": "#a31515",
		"textSeparator.foreground": "#0000002e",
		"titleBar.activeBackground": "#dddddd",
		"titleBar.activeForeground": "#333333",
		"titleBar.inactiveBackground": "#dddddd99",
		"titleBar.inactiveForeground": "#33333399",
		"tree.indentGuidesStroke": "#a9a9a9",
		"widget.shadow": "#00000029"
	}
}

export default vsLightTheme;
